import parsePhoneNumberFromString from 'libphonenumber-js';

export type TContactType = 'email' | 'phoneNumber' | 'whatsApp' | null;

export type TContactPayload = { email: string } | { phoneNumber: string };

const PHONE_CONTACT_TYPES: TContactType[] = ['phoneNumber', 'whatsApp'];

export const getContactPayload = (contact: string, type: TContactType): TContactPayload => {
  const value = contact.trim();
  const phone = parsePhoneNumberFromString(value);
  const isValidPhone = !!phone?.isValid();
  const isPhone = PHONE_CONTACT_TYPES.includes(type) || (!type && isValidPhone);

  if (!isPhone) return { email: value };

  return { phoneNumber: isValidPhone && phone ? phone.number : value };
};
